export default __webpack_public_path__ + "static/media/boschsans_regularItalic.80321191.woff";